import request from 'utils/request'

export const getMCAXS621InitRequest = () =>
  request({
    url: '/MCAXS621/init',
    method: 'post',
  })
